module.exports = __webpack_public_path__ + "static/media/notice.6a62c886.jpeg";